import { render, staticRenderFns } from "./Blockquote.vue?vue&type=template&id=642323b2&scoped=true"
import script from "./Blockquote.vue?vue&type=script&lang=js"
export * from "./Blockquote.vue?vue&type=script&lang=js"
import style0 from "./Blockquote.vue?vue&type=style&index=0&id=642323b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642323b2",
  null
  
)

export default component.exports